export function youtubeVideoId(text) {
    const value = text.trim();
    if (/^[a-zA-Z0-9_-]+$/.test(value)) return value;

    const parts = value.match(/^https?:\/\/((?:www\.|m\.)?youtube\.com|(?:www\.)?youtu\.be)\/([^?#\s]*)(?:\?([^#\s]*))?(?:#[^\s]*)?$/i);
    if (!parts) return null;

    const path = parts[2];
    let id;
    if (parts[1].toLowerCase().endsWith('youtu.be')) {
        id = path;
    } else if (path === 'watch') {
        const query = (parts[3] || '').match(/(?:^|&)v=([a-zA-Z0-9_-]+)(?:&|$)/);
        if (!query) return null;
        id = query[1];
    } else {
        const pathParts = path.match(/^(?:embed|shorts|live)\/([a-zA-Z0-9_-]+)$/);
        if (!pathParts) return null;
        id = pathParts[1];
    }

    return /^[a-zA-Z0-9_-]+$/.test(id) ? id : null;
}
